import { render } from "./updates.vue?vue&type=template&id=3ef41fc1&scoped=true"
import script from "./updates.vue?vue&type=script&lang=js"
export * from "./updates.vue?vue&type=script&lang=js"

import "./updates.vue?vue&type=style&index=0&id=3ef41fc1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef41fc1"]])

export default __exports__